import {Injectable,} from '@angular/core';
import {BehaviorSubject, Subject, takeUntil} from "rxjs";
import {BreadCrumbItem} from "../shared/model/bread-crumb-item";
import {isEmpty, TranslocoService} from "@ngneat/transloco";
import {Meta, Title} from "@angular/platform-browser";
import {TitleItem} from "../shared/model/title-item";
import {PageType} from "../shared/model/page-type";
import {LocaleService} from "./locale.service";

export class PageMetadata {
  static readonly DESCRIPTION = "description";
  static readonly KEYWORDS = "keywords";
}

const {
  DESCRIPTION,
  KEYWORDS
} = PageMetadata;

@Injectable({
  providedIn: 'root'
})
export class PageCommonsService {

  private breadCrumbItems = new BehaviorSubject([new BreadCrumbItem("&nbsp;", undefined, false)]);
  private pageTitle = new BehaviorSubject("&nbsp;");
  private _pageType = new BehaviorSubject(PageType.HOME);

  pageTitle$ = this.pageTitle.asObservable();
  breadCrumbItems$ = this.breadCrumbItems.asObservable();


  constructor(private localService: LocaleService, private translocoService: TranslocoService, protected title: Title, private metadata: Meta) {
  }

  changeMetadata(portalDescription: undefined | string, portalKeywords: undefined | string) {
    this.removeMetadata()
    if (portalDescription !== undefined) {
      this.metadata.addTag({DESCRIPTION: portalDescription})
    }
    if (portalKeywords !== undefined) {
      this.metadata.addTag({KEYWORDS: portalKeywords})
    }
  }

  changeTitle(data: string | undefined) {
    if (data === undefined) {
      return;
    }
    let value = data!;
    if (value === '&nbsp;') {
      value = '';
    }
    setTimeout(() => {
      this.pageTitle.next(value);
      this.title.setTitle(value);
    }, 0);
  }

  changeBreadCrumb(data: BreadCrumbItem[]) {
    let value = data!;
    setTimeout(() => {                           // <<<---using ()=> syntax
      this.breadCrumbItems.next(value);
    }, 0);
  }

  get pageType(): BehaviorSubject<PageType> {
    return this._pageType;
  }

  public changeDataBy(titleItem: TitleItem | undefined, itemsWithKeys: Array<BreadCrumbItem>) {
    this.langIsReady(this.localService.currentLocale, titleItem, itemsWithKeys);
  }

  private langIsReady(
    scope: string,
    x: TitleItem | undefined,
    y: Array<BreadCrumbItem>
  ) {
    if (isEmpty(this.translocoService.getTranslation(scope))) {
      const destroyListener$: Subject<void> = new Subject();
      this.translocoService.events$
        .pipe(takeUntil(destroyListener$.asObservable()))
        .subscribe((event) => {
          console.log(event);
          if (event.type === 'translationLoadSuccess' && event.payload.langName === scope) {
            this.internalChange(x, y);
            destroyListener$.next();
            destroyListener$.unsubscribe();
          }
        });
    } else {
      this.internalChange(x, y);
    }
  }

  private internalChange(titleItem: TitleItem | undefined, itemsWithKeys: Array<BreadCrumbItem>) {
    if (titleItem !== undefined) {
      if (titleItem.translated) {
        this.changeTitle(this.translate(titleItem.value!));
      } else {
        this.changeTitle(titleItem.value!)
      }
    }
    let result: Array<BreadCrumbItem> = [];
    if (itemsWithKeys !== undefined) {
      itemsWithKeys.forEach(x => {
        let y = new BreadCrumbItem(x.name, x.path, x.translated);
        if (x.translated) {
          y.name = this.translate(x.name!)
          y.translated = false;
        }
        if (y.name !== undefined && y.name?.length > 150) {
          y.name = y.name.substring(0, 150).concat(" ...");
        }
        result.push(y);
      });
      this.changeBreadCrumb(result);
    }
  }

  clearData() {
    this.pageTitle.next("&nbsp;");
    this.breadCrumbItems.next([new BreadCrumbItem("&nbsp;", undefined, false)]);
  }

  private translate(key: string) {
    try {
      return this.translocoService.translate(key);
    } finally {
    }
    return "";
  }

  private removeMetadata() {
    for (let key in PageMetadata) {
      this.metadata.removeTag(key);
    }
  }
}
